import { render, staticRenderFns } from "./CompleteRegistration.vue?vue&type=template&id=b6ce7bdc&scoped=true&"
import script from "./CompleteRegistration.vue?vue&type=script&lang=js&"
export * from "./CompleteRegistration.vue?vue&type=script&lang=js&"
import style0 from "./CompleteRegistration.vue?vue&type=style&index=0&id=b6ce7bdc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6ce7bdc",
  null
  
)

export default component.exports